import { msg } from "@lingui/core/macro";
import { createRoute, Outlet } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { useSession } from "@/lib/auth";
import { TodoListView } from "@/features/todos/components/todo-list-view";
import { getMyDayTodosCountQuery, getMyDayTodosQuery, nowISO } from "@listto/shared";
import { Sun } from "@fleet/icons";

import type { PowerSyncDrizzleDB } from "@listto/powersync";

import { useI18n } from "@/providers/i18n-provider";

function MyDayPage() {
  const { t } = useI18n();
  const session = useSession();
  const { userId } = session;

  return (
    <>
      <TodoListView
        title={t(msg`My Day`)}
        icon={Sun}
        userId={userId()}
        queryFn={(db: PowerSyncDrizzleDB, uid: string, options) =>
          getMyDayTodosQuery(db, uid, undefined, options)
        }
        countQueryFn={(dbInstance, uid) => getMyDayTodosCountQuery(dbInstance, uid)}
        defaultAddTodoProps={{ myDayDate: nowISO() }}
        emptyMessage={t(msg`Focus on your day. Tasks you add here will appear in this view.`)}
        listId="my-day"
        adPlacement="day-plan-done"
      />
      <Outlet />
    </>
  );
}

export const myDayRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/my-day",
  component: MyDayPage,
});
